










import Vue from 'vue'
import RouteAssistant from '@/helpers/route-assistant'
import AppSumoAssistant from '@/helpers/appsumo-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Only displays for admin/owners on tablet/desktop */
export default Vue.extend({
  name: 'NewProjectButton',

  props: {
    size: {
      type: String,
      default: 'large',
    },
    workflowId: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      RouteAssistant,
      ColorAssistant,
    }
  },
  methods: {
    async goToCreateProject() {
      if (
        await AppSumoAssistant.isUnderInternalProjectLimit(
          this.$router,
          this.$permissions,
        )
      ) {
        if (this.workflowId) {
          RouteAssistant.goToCreateProject(
            this.$router,
            this.$route.params.accountId,
            this.workflowId,
          )
        } else {
          RouteAssistant.goToCreateProject(
            this.$router,
            this.$route.params.accountId,
          )
        }
      }
    },
  },
})
